import { useLang } from 'hooks/lang';

import { Column, Row, Table, Button, Card } from 'components/Blocks';
import { UserAvatar } from 'components/UserAvatar';
import { ArrowRightIcon } from 'components/Icons';

import { RemoveProjectButton } from './RemoveProjectButton';

import { formatCurrency } from 'utils/text';
import { getTimestampDisplay } from 'utils/date';

import { usePackage } from './context';
import { actions } from 'entities';
import { downloadBuffer } from 'utils/download';
import { ExcelButton } from 'components/Buttons';

export function PackageProjects() {
  const { t } = useLang();

  const { data } = usePackage();

  const downloadExcel = actions.invoice.downloadPackageProjectsExcel.use({
    params: { packageId: data?.id },

    onSuccess: (excel) => {
      downloadBuffer(`${data.name}--projects-${new Date().toISOString()}.xlsx`, excel);
    },
  });

  if (!data?.projects.length) return null;

  return (
    <Column>
      <Row justifyContent="space-between">
        <h6 className="text-2xl font-medium text-primary phone:text-xl">{t('projects')}</h6>

        <ExcelButton
          {...downloadExcel.buttonProps}
          text={<span className="phone:hidden">{t('download')}</span>}
        />
      </Row>

      <Card>
        <Table
          items={data.projects}
          uniqueKey="id"
          spacing="medium"
          columns={[
            {
              label: t('project') as string,
              render: ({ project }) => project.name,
              search: true,
            },
            {
              label: t('owner') as string,
              render: ({ project }) => <UserAvatar user={project.owner} name />,
              filter: true,
              getTextValue: ({ project }) => project.owner.name,
            },
            {
              label: t('value') as string,
              render: ({ value, currency }) => formatCurrency(value, currency),
              filter: true,
              getTextValue: ({ currency }) => currency,
            },
            {
              label: t('associated-at') as string,
              render: ({ associatedAt }) => getTimestampDisplay(associatedAt),
            },
            {
              label: t('associated-by') as string,
              render: ({ associatedBy }) => <UserAvatar user={associatedBy} name />,
              filter: true,
              getTextValue: ({ associatedBy }) => associatedBy.name,
            },
            {
              render: ({ project }) => (
                <Row gap="2" justifyContent="flex-end" fullWidth={false}>
                  <RemoveProjectButton projectId={project.id} />

                  <Button variant="ghost" to="projectProfile" params={{ projectId: project.id }}>
                    {t('access')}
                    <ArrowRightIcon />
                  </Button>
                </Row>
              ),
            },
          ]}
        />
      </Card>
    </Column>
  );
}
